import * as React from 'react'
import * as css from './MultiCol.module.css'
import InnerBlock from './inner/InnerBlock'

const MultiCol = ({ _rawContent }) => {
  const col = (_rawContent?.length > 4 || _rawContent?.length === 3)
    ? 3
    : 2

  return (
    <section
      className={`${css.root} ctnr padding-x`}
      style={{ '--col': col }}
    >
      {_rawContent?.map((content, key) =>
        <InnerBlock {...content} key={key} />
      )}
    </section>
  )
}

export default MultiCol
